export default __webpack_public_path__ + "static/media/store.17155d23.svg";